
const createEndlessGridSlick = function($list) {
    var next = $list.data('next');
    var prev = $list.data('prev');
    var loop = $list.data('loop');
    var size = $list.data('size');

    var slidesToShow = endldessGrid_slidesToShow(size);

    if ($(window).width() < 1170) {
        $slide = '.ttg-endless-carousel-item:not(.hidden-sm)';
    } else {
        $slide = '.ttg-endless-carousel-item';
    }

    if ($list.find($slide).length > slidesToShow) {
        $list.on('init', function(event, slick, currentSlide) {
            $list.find('.slick-slide a').attr('tabindex', -1);
            $list.find('.slick-slide.slick-active a').removeAttr('tabindex');

            color_indicators(1, $list.next(), slidesToShow);
            $list.next().show();
        });

        $list.slick({
            accessibility: false,
            slidesToShow: slidesToShow,
            variableWidth: true,
            swipeToSlide: true,
            infinite: loop,
            slide: $slide,
            prevArrow: '<button class="slick-prev" type="button"><span class="fa-regular fa-chevron-left" aria-hidden="true"></span><span class="sr-only">' + prev + '</span></button>',
            nextArrow: '<button class="slick-next" type="button"><span class="fa-regular fa-chevron-right" aria-hidden="true"></span><span class="sr-only">' + next + '</span></button>',
        }).on('afterChange', function(event, slick, currentSlide) {
            $list.find('.slick-slide a').attr('tabindex', -1);
            $list.find('.slick-slide.slick-active a').removeAttr('tabindex');
        }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            color_indicators(nextSlide + 1, $list.next(), slidesToShow);
        });
    } else {
        $list.addClass('ttg-endless-grid-no-carousel');
    }
};


const endldessGrid_slidesToShow = function(size) {
    var number;
    if (size == "small") {
        number = Math.floor($(window).width() / 360);
    } else {
        number = Math.floor($(window).width() / 750);
    }

    if ($(window).width() < 1170) {
        return 1;
    } else {
        return number;
    }
};

//Endless Grid
$(".ttg-endless-grid-carousel").each(function() {
    createEndlessGridSlick($(this));
});